module.exports = __webpack_public_path__ + "static/project-4-c59171726f0c8e03ba8d9cd7e2254900.jpg";